import { css } from 'styled-components'

/**
 * Reusable tier color styles
 */
export const tierGradientBackgroundStyle = css`
  &.tier-bronze {
    background: ${props => props.theme.palette.product.loyalty.bronze.gradientPrimaryBackground};
  }

  &.tier-silver {
    background: ${props => props.theme.palette.product.loyalty.silver.gradientPrimaryBackground};
  }

  &.tier-gold {
    background: ${props => props.theme.palette.product.loyalty.gold.gradientPrimaryBackground};
  }

  &.tier-platinum {
    background: ${props => props.theme.palette.product.loyalty.platinum.gradientPrimaryBackground};
  }

  &.tier-infinite {
    background: ${props => props.theme.palette.product.loyalty.infinite.gradientPrimaryBackground};
  }
`

/**
 * Tier darkBackground color styles (for icon badges, accent backgrounds)
 */
export const tierDarkBackgroundStyle = css`
  &.tier-bronze {
    background: ${props => props.theme.palette.product.loyalty.bronze.darkBackground};
  }

  &.tier-silver {
    background: ${props => props.theme.palette.product.loyalty.silver.darkBackground};
  }

  &.tier-gold {
    background: ${props => props.theme.palette.product.loyalty.gold.darkBackground};
  }

  &.tier-platinum {
    background: ${props => props.theme.palette.product.loyalty.platinum.darkBackground};
  }

  &.tier-infinite {
    background: ${props => props.theme.palette.product.loyalty.infinite.darkBackground};
  }
`

/**
 * Tier dark accents color styles (for accents, not backgrounds)
 */
export const tierDarkAccentsStyle = css`
  &.tier-bronze {
    background: ${props => props.theme.palette.product.loyalty.bronze.darkBackground};
  }

  &.tier-silver {
    background: ${props => props.theme.palette.product.loyalty.silver.darkBackground};
  }

  &.tier-gold {
    background: ${props => props.theme.palette.product.loyalty.gold.normalBackground};
  }

  &.tier-platinum {
    background: ${props => props.theme.palette.product.loyalty.platinum.darkBackground};
  }

  &.tier-infinite {
    background: ${props => props.theme.palette.product.loyalty.infinite.darkBackground};
  }
`

/**
 * Tier lightContrast color styles (for text on gradient backgrounds)
 */
export const tierLightContrastColorStyle = css`
  &.tier-bronze {
    color: ${props => props.theme.palette.product.loyalty.bronze.lightContrast};
  }

  &.tier-silver {
    color: ${props => props.theme.palette.product.loyalty.silver.lightContrast};
  }

  &.tier-gold {
    color: ${props => props.theme.palette.product.loyalty.gold.lightContrast};
  }

  &.tier-platinum {
    color: ${props => props.theme.palette.product.loyalty.platinum.lightContrast};
  }

  &.tier-infinite {
    color: ${props => props.theme.palette.product.loyalty.infinite.lightContrast};
  }
`

/**
 * Tier lightBackground styles (for light pills/badges sitting on a tier background)
 */
export const tierLightBackgroundStyle = css`
  &.tier-bronze {
    background-color: ${props => props.theme.palette.product.loyalty.bronze.lightBackground};
  }

  &.tier-silver {
    background-color: ${props => props.theme.palette.product.loyalty.silver.lightBackground};
  }

  &.tier-gold {
    background-color: ${props => props.theme.palette.product.loyalty.gold.lightBackground};
  }

  &.tier-platinum {
    background-color: ${props => props.theme.palette.product.loyalty.platinum.lightBackground};
  }

  &.tier-infinite {
    background-color: ${props => props.theme.palette.product.loyalty.infinite.lightBackground};
  }
`

/**
 * Tier normalContrast background color styles (for dividers, accents)
 */
export const tierNormalContrastBackgroundStyle = css`
  &.tier-bronze {
    background-color: ${props => props.theme.palette.product.loyalty.bronze.normalContrast};
  }

  &.tier-silver {
    background-color: ${props => props.theme.palette.product.loyalty.silver.normalContrast};
  }

  &.tier-gold {
    background-color: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
  }

  &.tier-platinum {
    background-color: ${props => props.theme.palette.product.loyalty.platinum.normalContrast};
  }

  &.tier-infinite {
    background-color: ${props => props.theme.palette.product.loyalty.infinite.normalContrast};
  }
`

/**
 * Tier darkContrast color styles (for text on dark tier backgrounds)
 */
export const tierDarkContrastColorStyle = css`
  &.tier-bronze {
    color: ${props => props.theme.palette.product.loyalty.bronze.darkContrast};
  }

  &.tier-silver {
    color: ${props => props.theme.palette.product.loyalty.silver.darkContrast};
  }

  &.tier-gold {
    color: ${props => props.theme.palette.product.loyalty.gold.darkContrast};
  }

  &.tier-platinum {
    color: ${props => props.theme.palette.product.loyalty.platinum.darkContrast};
  }

  &.tier-infinite {
    color: ${props => props.theme.palette.product.loyalty.infinite.darkContrast};
  }
`

/**
 * Tier normalBackground styles (for badge/label backgrounds)
 */
export const tierNormalBackgroundStyle = css`
  &.tier-bronze {
    background-color: ${props => props.theme.palette.product.loyalty.bronze.normalBackground};
  }

  &.tier-silver {
    background-color: ${props => props.theme.palette.product.loyalty.silver.normalBackground};
  }

  &.tier-gold {
    background-color: ${props => props.theme.palette.product.loyalty.gold.normalBackground};
  }

  &.tier-platinum {
    background-color: ${props => props.theme.palette.product.loyalty.platinum.normalBackground};
  }

  &.tier-infinite {
    background-color: ${props => props.theme.palette.product.loyalty.infinite.normalBackground};
  }
`

/**
 * Tier normalContrast color styles (for text)
 */
export const tierNormalContrastColorStyle = css`
  &.tier-bronze {
    color: ${props => props.theme.palette.product.loyalty.bronze.normalContrast};
  }

  &.tier-silver {
    color: ${props => props.theme.palette.product.loyalty.silver.normalContrast};
  }

  &.tier-gold {
    color: ${props => props.theme.palette.product.loyalty.gold.normalContrast};
  }

  &.tier-platinum {
    color: ${props => props.theme.palette.product.loyalty.platinum.normalContrast};
  }

  &.tier-infinite {
    color: ${props => props.theme.palette.product.loyalty.infinite.normalContrast};
  }
`

/**
 * Tier normalBackground + normalContrast styles (for tier-colored badges/labels)
 */
export const tierNormalBadgeStyle = css`
  ${tierNormalBackgroundStyle}
  ${tierNormalContrastColorStyle}
`

/**
 * Tier gradient secondary background (e.g. banner pills, secondary panels).
 */
export const tierGradientSecondaryBackgroundStyle = css`
  &.tier-bronze {
    background: ${props => props.theme.palette.product.loyalty.bronze.gradientSecondaryBackground};
  }

  &.tier-silver {
    background: ${props => props.theme.palette.product.loyalty.silver.gradientSecondaryBackground};
  }

  &.tier-gold {
    background: ${props => props.theme.palette.product.loyalty.gold.gradientSecondaryBackground};
  }

  &.tier-platinum {
    background: ${props => props.theme.palette.product.loyalty.platinum.gradientSecondaryBackground};
  }

  &.tier-infinite {
    background: ${props => props.theme.palette.product.loyalty.infinite.gradientSecondaryBackground};
  }
`

/**
 * Tier darkForeground color styles (for tier-accented text on a light background)
 */
export const tierDarkForegroundColorStyle = css`
  &.tier-bronze {
    color: ${props => props.theme.palette.product.loyalty.bronze.darkForeground};
  }

  &.tier-silver {
    color: ${props => props.theme.palette.product.loyalty.silver.darkForeground};
  }

  &.tier-gold {
    color: ${props => props.theme.palette.product.loyalty.gold.darkForeground};
  }

  &.tier-platinum {
    color: ${props => props.theme.palette.product.loyalty.platinum.darkForeground};
  }

  &.tier-infinite {
    color: ${props => props.theme.palette.product.loyalty.infinite.darkForeground};
  }
`

/**
 * Tier darkForeground border colour styles (for outlining a surface in the tier's colour)
 */
export const tierDarkForegroundBorderColorStyle = css`
  &.tier-bronze {
    border-color: ${props => props.theme.palette.product.loyalty.bronze.darkForeground};
  }

  &.tier-silver {
    border-color: ${props => props.theme.palette.product.loyalty.silver.darkForeground};
  }

  &.tier-gold {
    border-color: ${props => props.theme.palette.product.loyalty.gold.darkForeground};
  }

  &.tier-platinum {
    border-color: ${props => props.theme.palette.product.loyalty.platinum.darkForeground};
  }

  &.tier-infinite {
    border-color: ${props => props.theme.palette.product.loyalty.infinite.darkForeground};
  }
`
